<template>
  <div style="background: #f8fafc; min-height: 100vh; font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;">
    <!-- Hero Section -->
    <div style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; padding: 60px 0; margin: -20px -20px 40px -20px; position: relative; overflow: hidden;">
      <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: radial-gradient(circle at 20% 50%, rgba(255,255,255,0.1) 1px, transparent 1px), radial-gradient(circle at 80% 50%, rgba(255,255,255,0.1) 1px, transparent 1px); background-size: 50px 50px; opacity: 0.3;"></div>
      <div class="container text-center" style="position: relative; z-index: 2;">
        <h1 style="font-size: 3rem; font-weight: 800; margin-bottom: 16px; letter-spacing: -1px; text-shadow: 0 2px 4px rgba(0,0,0,0.1);">Our Services</h1>
        <p style="font-size: 1.2rem; opacity: 0.95; max-width: 600px; margin: 0 auto 30px; line-height: 1.6;">Expert solutions to help your business succeed in the digital world</p>
      </div>
    </div>

    <!-- Services Section -->
    <div class="container py-5">
      <div class="row">
        <PlatformMaintenance />
        <DevelopmentServices />
        <AWSCloudArchitecture />
        <AWSDevops />
        <AwsMigration />
        <ApiDevelopment />
        <ApplicationDevelopment />
        <DatabaseDesign />
      </div>
    </div>
  </div>
</template>

<script setup>
// Import the ServiceCard component

import PlatformMaintenance from '~/components/services/PlatformMaintenance.vue';
import DevelopmentServices from '~/components/services/DevelopmentServices.vue';
import AWSCloudArchitecture from '~/components/services/AWSCloudArchitecture.vue';
import ApiDevelopment from '~/components/services/ApiDevelopment.vue';
import ApplicationDevelopment from '~/components/services/ApplicationDevelopment.vue';
import DatabaseDesign from '~/components/services/DatabaseDesign.vue';
import AwsMigration from '~/components/services/AwsMigration.vue';
import AWSDevops from '~/components/services/AWSDevops.vue';

// Services index page
definePageMeta({
  layout: 'default',
  title: 'Our Services'
})

useHead({
  title: 'Our Services - Geek Cafe',
  meta: [
    { name: 'description', content: 'Explore our range of professional services including AWS cloud architecture, API design, application development, and more.' }
  ]
})
</script>
